(function () {
    const mq = window.matchMedia('(min-width: 1024px)');
    let inited = false;
    let cleanup = () => { };

    function initDesktopPreview() {
        const leftCol = document.querySelector('.menu > li.menu-item:nth-of-type(1) > .sub-menu > li:nth-of-type(1)');
        if (!leftCol) return () => { };

        const box = document.createElement('div');
        box.className = 'menu-cat-illustration';
        leftCol.prepend(box);

        const links = leftCol.querySelectorAll('a[data-cat-img]');
        function showImg(a) {
            const url = a?.dataset?.catImg || '';
            if (!url) { box.classList.remove('has-img'); box.style.backgroundImage = ''; return; }
            box.style.backgroundImage = 'url(' + url + ')';
            box.classList.add('has-img');
        }

        const onEnter = e => showImg(e.currentTarget);
        links.forEach(a => {
            a.addEventListener('mouseenter', onEnter);
            a.addEventListener('focus', onEnter);
        });

        for (const a of links) { if (a.dataset.catImg) { showImg(a); break; } }

        return function destroy() {
            links.forEach(a => {
                a.removeEventListener('mouseenter', onEnter);
                a.removeEventListener('focus', onEnter);
            });
            box.remove();
        };
    }

    function check() {
        if (mq.matches && !inited) {
            cleanup = initDesktopPreview() || (() => { });
            inited = true;
        } else if (!mq.matches && inited) {
            cleanup(); inited = false;
        }
    }

    document.addEventListener('DOMContentLoaded', check);
    mq.addEventListener('change', check);
})();
